import { Polyline } from 'react-leaflet';

const StormTrack = ({ positions, casingPathOptions, trackPathOptions }) => {
  if (positions.length < 2) return null;

  return (
    <>
      <Polyline positions={positions} pathOptions={casingPathOptions} />
      <Polyline positions={positions} pathOptions={trackPathOptions} />
    </>
  );
};

export default StormTrack;
